import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=65e51aad&scoped=true&"
import script from "./Development.vue?vue&type=script&lang=js&"
export * from "./Development.vue?vue&type=script&lang=js&"
import style0 from "./Development.vue?vue&type=style&index=0&id=65e51aad&prod&lang=scss&"
import style1 from "./Development.vue?vue&type=style&index=1&id=65e51aad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e51aad",
  null
  
)

export default component.exports